@if (isGuestFlow()) {
  <div
    class="fixed bottom-0 left-0 right-0 z-50 w-full bg-surface-0/95 dark:bg-surface-900/95 backdrop-blur-sm border-t border-surface-200 dark:border-surface-700 px-4 py-2 flex items-center justify-center gap-3 text-sm"
    *transloco="let t"
  >
    <span class="text-surface-500 dark:text-surface-400">
      {{ t('guestBanner.identifiedWith') }}
      <span class="font-medium text-surface-700 dark:text-surface-200">{{ guestEmail() }}</span>
    </span>
    <span class="text-surface-300 dark:text-surface-600">·</span>
    <button
      type="button"
      class="text-red-500 hover:text-red-600 hover:underline font-medium transition-colors"
      (click)="openResetModal()"
    >
      {{ t('guestBanner.resetButton') }}
    </button>
  </div>

  <d2d-reset-confirmation-modal (confirmed)="reset()" />
}
